import { graphql } from 'gatsby'
import React, { FC } from 'react'
import styled from 'styled-components'

import useSiteSettings from '../../../hooks/useSiteSettings'

const StyledLegalFootnote = styled.div`
  color: ${({ theme }) => theme.colors.coolGray.cool500};
  margin-top: 10px;
`

export const FooterLegalFootnotes: FC = () => {
  const { footerLegalFootnotes } = useSiteSettings() || {}

  return (
    <>
      {footerLegalFootnotes &&
        footerLegalFootnotes.reduce((acc: React.ReactElement[], text, index) => {
          if (!text) return acc
          acc.push(<StyledLegalFootnote key={index}>{text}</StyledLegalFootnote>)
          return acc
        }, [])}
    </>
  )
}

export const footerLegalMenu = graphql`
  fragment footerLegalFootnotesFragment on SanitySiteSettings {
    footerLegalFootnotes
  }
`
